import { checkPGsByCountryPrecondition, getSubscriptionPeriodicitiesByCountryAndProductType } from '@utils/FilterUtils';
import { getProductGroupsByCountry, getProductGroupsMasterByCountry } from '@services/ProductGroup.service';
import { filterPGsByCountry, updateCountryAndPGFilters } from '@utils/CountryUtils';

export const updateCountryPgSideFilter = async ({
  retailerClientState,
  periodicity,
  appliedCountries,
  selectedCountries,
  effectiveProductType,
  pagesConfig,
  responseConfig,
}) => {
  const { clientId } = retailerClientState;

  if (
    !checkPGsByCountryPrecondition(pagesConfig, clientId, periodicity, pagesConfig.appliedFilters, appliedCountries)
  ) {
    return;
  }

  pagesConfig.setSelectedTimeFrame(periodicity);

  const timeFrames = getSubscriptionPeriodicitiesByCountryAndProductType(
    effectiveProductType,
    pagesConfig,
    selectedCountries,
  );

  if (!timeFrames || timeFrames.length === 0) {
    return;
  }

  let pgs = await getProductGroupsByCountry(clientId, selectedCountries, effectiveProductType);

  const pgsByCountry = filterPGsByCountry(pgs, selectedCountries);

  updateCountryAndPGFilters(
    pagesConfig,
    selectedCountries,
    pgsByCountry,
    responseConfig.response[0],
    effectiveProductType,
  );

  if (pagesConfig.masterPgsByCountry.length === 0) {
    try {
      const availableMasterPgs = await getProductGroupsMasterByCountry(
        clientId,
        appliedCountries,
        effectiveProductType,
      );
      pagesConfig.setPGsByAppliedCountry(pgsByCountry);
      pagesConfig.setMasterPgsByCountry(availableMasterPgs);
    } catch (error) {
      pagesConfig.setMasterPgsByCountry([]);
      console.error(error);
    }
  }
};
